import React from 'react';

const CourseTabs = ({ activeTab, onTabChange,isLocked }) => {
  return (
    <div className="row border-bottom  justify-content-center">
      <div
        className={`col-3 course-tab ${activeTab === 'overview' ? 'active' : ''}`}
        onClick={() => onTabChange('overview')}
      >
        Overview
        <div className={`custom-border-bottom-${activeTab === 'overview' ? 'active' : ''}`}>

        </div>
      </div>
      <div
        className={`col-3 course-tab ${activeTab === 'courseMaterial' ? 'active' : ''}`}
        onClick={() => onTabChange('courseMaterial')}
      >
        Course Material
        <div className={`custom-border-bottom-${activeTab === 'courseMaterial' ? 'active' : ''}`}>

        </div>
      </div>
       <div
        className={`col-3 course-tab ${activeTab === 'quizSection' ? 'active' : ''} ${isLocked ? 'disabled' : ''}`}
        onClick={() => {
          if (!isLocked) {
            onTabChange('quizSection');
          }
        }}
        style={{
          cursor: isLocked ? 'not-allowed' : 'pointer',
          opacity: isLocked ? 0.5 : 1,
        }}
      >
        Quiz Section
        <span className='ps-2'>
           <i className={`bi ${isLocked ? "bi-lock" : "bi-unlock"}`}></i>
        </span>
        <div className={`custom-border-bottom-${activeTab === 'quizSection' ? 'active' : ''}`}></div>
      </div>
    </div>
  );
};

export default CourseTabs;